// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blogs{margin-bottom:5rem}.blogs .h1{margin-bottom:0}.blogs .text-container{overflow:hidden;text-overflow:hidden;height:10rem}.blogs #continue:hover{text-decoration:underline}", ""]);
// Exports
module.exports = exports;
